import styled from 'styled-components'

export const CardContent = styled.div`
  padding: 24px 24px 24px 24px;
  display: block;
  line-height: 150%;
`
